import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../core/form/Button';
import { browserHistory } from 'react-router';
import Separator from '../../../../core/layout/Separator';
import Card from '../../../../core/layout/Card';

const MasteryTestItemHistoryDetail = (props) => (
  <Card
    title="Item details"
    loading={props.fetching}
    actions={<Button icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
  >
    <div>
      <strong>Module</strong>: <span>{props.masteryTestItem.masteryTest.module.name}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <strong>Mastery Test</strong>: <span>{props.masteryTestItem.masteryTest.modulePercentageToActive}%</span>
    </div>
    <Separator size="xxs" />
    <div>
      <strong>Order</strong>: <span>{props.masteryTestItem.order}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <strong>Text</strong>: <span>{props.masteryTestItem.item.text}</span>
    </div>
  </Card>
);

MasteryTestItemHistoryDetail.propTypes = {
  fetching: PropTypes.bool,
  masteryTestItem: PropTypes.shape({
    order: PropTypes.number.isRequired,
    masteryTest: PropTypes.shape({
      modulePercentageToActive: PropTypes.number.isRequired,
      module: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

MasteryTestItemHistoryDetail.defaultProps = {
  fetching: false,
};

export default MasteryTestItemHistoryDetail;
